module.exports = __webpack_public_path__ + "static/bbq-4-bf8902255a45eb08a3eb88becfc4547d.png";